import React from 'react';
import { EmptyState } from '@modules/Dashboard/components/EmptyState';
export const MembershipsAnalytics = () => {
    return (React.createElement("div", { style: { gridColumn: '1 / 4' } },
        React.createElement(EmptyState.Root, { title: "There are no any memberships reports yet", subtitle: "Please be patient" })));
};
